import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AccountService } from '@application/services/account.service';

@Injectable({ providedIn: 'root' })
export class AuthInterceptor implements CanActivate {
  constructor(private router: Router, private accountService: AccountService) {}

  public async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    await this.accountService.verifyLogin();
    if (!this.accountService.hasLogin()) {
    }
    return true;
  }
}
